module.exports = __webpack_public_path__ + "img/ssyx_03.742505a6.jpg";